import React, { Component } from 'react';
import { arrayOf, object } from 'prop-types';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { Provider } from 'react-redux';
import { PAGES, THEMES } from 'common/const';
import { ErrorBoundary, AppContext, Page } from './components';

import DeliveriedFilePage from './pages/DeliveriedFilePage';
import ExtractedFilePage from './pages/ExtractedFilePage';
import { SummaryReportPage } from './tracker';

import './app.css';

const Routes = ({ pages }) => {
    return (
        <Switch>
            {pages.map(({ path, component, exact }) => (
                <Route key={path} exact={exact} path={path}>
                    {data => (
                        <AppContext.Consumer>
                            {ctx => {
                                return (
                                    <Page
                                        component={component}
                                        data={data}
                                        ctx={ctx}
                                    />
                                );
                            }}
                        </AppContext.Consumer>
                    )}
                </Route>
            ))}
        </Switch>
    );
};

class AppPage extends Component {
    constructor(props) {
        super(props);

        this.handleChangePage = page => {
            this.setState({ page });
        };

        this.handleChangeTheme = theme => {
            this.setState({ theme });
        };

        this.state = {
            page: PAGES.LANDING,
            theme: THEMES.TEAL,
            changePage: this.handleChangePage,
            changeTheme: this.handleChangeTheme
        };
    }

    static propTypes = {
        pages: arrayOf(object).isRequired
    };

    static defaultProps = {
        pages: [
            {
                title: '',
                path: PAGES.EXTRACTED,
                component: ExtractedFilePage,
                exact: true
            },
            {
                title: '',
                path: PAGES.DELIVERY,
                component: DeliveriedFilePage,
                exact: true
            },
            {
                title: '',
                path: PAGES.SUMMARY,
                component: SummaryReportPage,
                exact: true
            }
        ]
    };

    render() {
        const { pages, store } = this.props;

        return (
            <Provider store={store}>
                <BrowserRouter>
                    <AppContext.Provider value={this.state}>
                        <ErrorBoundary>
                            <div className="page-container">
                                <Routes pages={pages} />
                            </div>
                        </ErrorBoundary>
                    </AppContext.Provider>
                </BrowserRouter>
            </Provider>
        );
    }
}

export default AppPage;
